import { render } from "./Departement.vue?vue&type=template&id=253564ab"
import script from "./Departement.vue?vue&type=script&lang=js"
export * from "./Departement.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\LMPELCHAT\\Documents\\vie-associative\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__